<template>
  <div class="step-question-template">
    <div class="question-text" role="heading" aria-level="3" v-html="question.questionText"></div>
    <div class="question-description" v-html="question.questionDescription"></div>
    <div class="mt-8 mb-4">{{ isDe ? "Ihre Größe" : "Height" }}</div>
    <HeightInput
      :measurement-systems="measurementSystems"
      :initial-value="question?.response?.height"
      :style-props="heightInputStyle"
      @value-updated="onHeightValueUpdated"
    />

    <div class="mt-10 mb-4">{{ isDe ? "Ihr Gewicht" : "Weight" }}</div>
    <WeightInput
      :measurement-systems="measurementSystems"
      :initial-value="question?.response?.weight"
      :style-props="weightInputStyle"
      @value-updated="onWeightValueUpdated"
    />
    <div class="mt-8" v-if="isDe">
      <InfoAlert>
        Hinweis: Vor der Rezeptausstellung müssen Sie ein Ganzkörperfoto hochladen. Unser Ärzteteam prüft damit Ihr
        Gewicht und ob das Medikament für Sie geeignet ist. Ihr Foto wird vertraulich behandelt und nur für die
        Rezeptausstellung verwendet.
      </InfoAlert>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import poster from "../../mixins/poster";
import responseAdapters from "@/Consultation/mixins/responseAdapters";
import { HeightInputStyleProps, MeasurementSystem, SimpleBmiQuestion, WeightInputStyleProps } from "../../types";
import WeightInput, { WeightValueUpdatedEvent } from "../common/bmi/WeightInput.vue";
import HeightInput, { HeightValueUpdatedEvent } from "../common/bmi/HeightInput.vue";
import InfoAlert from "@/ComponentLibrary/InfoAlert";

export default Vue.extend({
  components: {
    HeightInput,
    WeightInput,
  },
  mixins: [poster],
  props: {
    question: { type: Object as PropType<SimpleBmiQuestion>, required: true },
    measurementSystems: { type: Array as PropType<MeasurementSystem[]>, required: true },
    weightInputStyle: { type: Object as PropType<WeightInputStyleProps>, required: true },
    heightInputStyle: { type: Object as PropType<HeightInputStyleProps>, required: true },
    showRequired: { required: true },
  },
  data() {
    return {
      isHeightComplete: false,
      isHeightValid: false,
      isWeightComplete: false,
      isWeightValid: false,
      responseAdapter: responseAdapters.simpleBmi,
    };
  },
  methods: {
    updateNextButton() {
      this.$emit("update-next-button-status", this.isComplete && this.isValid);
    },
    onHeightValueUpdated(event: HeightValueUpdatedEvent) {
      this.isHeightComplete = event.isComplete;

      this.isHeightValid = event.isValid;

      this.question.response = {
        ...this.question.response,
        height: event.value,
      };

      this.updateNextButton();
    },
    onWeightValueUpdated(event: WeightValueUpdatedEvent) {
      this.isWeightComplete = event.isComplete;

      this.isWeightValid = event.isValid;

      this.question.response = {
        ...this.question.response,
        weight: event.value,
      };

      this.updateNextButton();
    },
  },
  computed: {
    isComplete: function () {
      return this.isHeightComplete && this.isWeightComplete;
    },
    isValid: function () {
      return this.isHeightValid && this.isWeightValid;
    },
    isDe() {
      return process.env.REGION == "de";
    },
  },
});
</script>
